import React, { PropsWithChildren } from "react";

const MinusIcon = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="3"
      fill="none"
      viewBox="0 0 17 3"
      {...props}
    >
      <path
        fill="#522398"
        d="M16.406.719H.594a.339.339 0 00-.344.344v1.375c0 .214.129.343.344.343h15.812a.339.339 0 00.344-.344V1.063a.37.37 0 00-.344-.344z"
      ></path>
    </svg>
  );
};

export default React.memo(MinusIcon);
